import { render } from "./page-about-us.vue?vue&type=template&id=41f9bcc3&scoped=true"
import script from "./page-about-us.vue?vue&type=script&lang=js"
export * from "./page-about-us.vue?vue&type=script&lang=js"

import "./page-about-us.vue?vue&type=style&index=0&id=41f9bcc3&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f9bcc3"]])

export default __exports__